import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/admin/ProtectedRoute';
import AdminLayout from '../components/admin/AdminLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const DashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AuftraegePage = lazy(() => import('../pages/admin/auftraege/page'));
const UserAdministrationPage = lazy(() => import('../pages/admin/user-administration/page'));
const UserProfilePage = lazy(() => import('../pages/admin/user-profile/page'));
const EinsatztagePage = lazy(() => import('../pages/admin/einsatztage/page'));
const EinstellungenPage = lazy(() => import('../pages/admin/einstellungen/page'));
const SeedTestDataPage = lazy(() => import('../pages/admin/seed-test-data/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  // Neue Einstiegsseite für Betreiber
  {
    path: '/kurier',
    element: <AdminPage />,
  },
  {
    path: '/kurier',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'auftraege',
        element: <AuftraegePage />,
      },
      {
        path: 'user-administration',
        element: <UserAdministrationPage />,
      },
      {
        path: 'user-profile',
        element: <UserProfilePage />,
      },
      {
        path: 'einsatztage',
        element: <EinsatztagePage />,
      },
      {
        path: 'einstellungen',
        element: <EinstellungenPage />,
      },
      {
        path: 'seed-test-data',
        element: <SeedTestDataPage />,
      },
    ],
  },
  // Alte /admin-Routen weiterleiten
  {
    path: '/admin',
    element: <Navigate to="/kurier" replace />,
  },
  {
    path: '/admin/dashboard',
    element: <Navigate to="/kurier/dashboard" replace />,
  },
  {
    path: '/admin/user-administration',
    element: <Navigate to="/kurier/user-administration" replace />,
  },
  {
    path: '/admin/user-profile',
    element: <Navigate to="/kurier/user-profile" replace />,
  },
  {
    path: '/admin/einsatztage',
    element: <Navigate to="/kurier/einsatztage" replace />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;